import * as toastr from 'toastr';

export class ToastService {
  constructor() {
    toastr.options.positionClass = 'toast-bottom-center';
    toastr.options.timeOut = 3000;
  }

  success(message: string, title?: string) {
    toastr.success(message, title);
  }

  error(message: string, title?: string) {
    toastr.error(message, title);
  }
}